import { lazy } from 'react';

export const Maps = lazy(() => import('../pages/Map'));
export const Notfound = lazy(() => import('../pages/Notfound'));
export const Client = lazy(() => import('../pages/Clients'));
export const User = lazy(() => import('../pages/WebUsers'));
export const Project = lazy(() => import('../pages/Projects'));
export const SignIn = lazy(() => import('../pages/SignIn'));
// export const ProductsCatalogue = lazy(() => import('../pages/Products_catalogue'),);
export const Infestation = lazy(() => import('../pages/Infestations'));
// export const ProductRecommendation = lazy(() => import('../components/product/ProductRecommendation'),);
export const UserProfile = lazy(() => import('../pages/UserProfile'));
export const Crops = lazy(() => import('../pages/Crops'));
export const CropVarieties = lazy(() => import('../pages/Crops/Varieties'));
export const PracticeCalendar = lazy(
  () => import('../pages/Crops/PracticeCalendar'),
);
export const InfestationLevelDetails = lazy(
  () => import('../pages/Infestations/LevelDetails'),
);
export const InfestationSymptoms = lazy(
  () => import('../pages/Infestations/Symptoms'),
);
export const CreateInfestation = lazy(
  () => import('../pages/Infestations/Create'),
);
export const Farm = lazy(() => import('../pages/Farms'));
export const FieldLocations = lazy(() => import('../pages/FieldLocations'));
export const Observations = lazy(() => import('../pages/Observations'));
export const FarmHistory = lazy(() => import('../pages/Farms/FarmHistory'));
export const ObservationList = lazy(
  () => import('../pages/Observations/ObservationList'),
);
export const SoilTypes = lazy(() => import('../pages/SoilTypes'));
export const ForgotPassword = lazy(
  () => import('../pages/SignIn/ForgotPassword'),
);
export const ResetPassword = lazy(
  () => import('../pages/SignIn/ResetPassword'),
);
export const CreateConfiguration = lazy(
  () => import('../pages/Configurations/Create'),
);
export const Configuration = lazy(() => import('../pages/Configurations'));
export const ConfigurationView = lazy(
  () => import('../pages/Configurations/View'),
);
export const FeedbackQuestions = lazy(() => import('../pages/FeedbackMaster'));
export const FeedbackResponses = lazy(() => import('../pages/UserFeedbacks'));
export const FeedbackReport = lazy(() => import('../pages/FeedbackReport'));
export const DeviceRequests = lazy(() => import('../pages/DeviceRequests'));
export const Notifications = lazy(() => import('../pages/Notifications'));
export const SmsNotifications = lazy(() => import('../pages/SmsNotifications'));
export const CropStages = lazy(() => import('../pages/Crops/Stages'));
export const InfestationParameters = lazy(
  () => import('../pages/InfestationParameters'),
);
export const AnalyticsDashboard = lazy(() => import('../pages/Dashboard'));
export const Farmers = lazy(() => import('../pages/Farmers'));
export const FieldAgents = lazy(() => import('../pages/FieldAgents'));
export const Schemes = lazy(() => import('../pages/Schemes'));
export const CreateScheme = lazy(() => import('../pages/Schemes/Create'));
